// gets a value out of local storage and then parses it
export default function (key: string): string | undefined {
  try {
    return JSON.parse(localStorage.getItem(key) || '');
  } catch {
    return undefined;
  }
}
